import photo from './photo.vue'
export default photo